import PropTypes from 'prop-types';
import React, {useRef} from 'react';
import {IMAGES_PATHS} from '../../../consts';
import ZepzPayinPropTypes from '../../pages/ZepzPayin/zepz-payin.proptypes';
import ZepzCreditCard from '../ZepzCreditCard';
import {useZepzCardSelection} from './zepz-card-selection.hooks';

const ZepzCardSelection = ({
    cards,
    csrfToken,
    translations,
    genericError,
    dispatch,
    toggleFormVisibility,
    platform,
    removeCard,
    languageCode,
    paymentSessionId
}) => {
    const threeDSContainer = useRef();
    const threeDSData = {
        languageCode,
        container: threeDSContainer,
        paymentSessionId
    };

    const {
        isSubmitting,
        onSubmit
    } = useZepzCardSelection({
        dispatch, csrfToken, platform, threeDSData
    });

    return (
        <section className="card-selection-container">
            <div className="centered-container" id="credit-cards-container">
                <h1>{translations.creditCard.heading}</h1>
                <div className="call-to-action-box card-selection-cta-box">
                    <button
                        id="add-new-card"
                        type="button"
                        className="show-form"
                        disabled={genericError}
                        onClick={toggleFormVisibility}
                    >
                        <div className="heading-with-icon">
                            <img
                                className="heading-with-icon-img"
                                src={IMAGES_PATHS.CREDIT_CARD_ADD_RELAUNCH}
                                alt="add"
                            />
                            <h2>
                                {translations.creditCard.add}
                            </h2>
                        </div>
                    </button>
                </div>

                <h4 className="option-credit">
                    {translations.creditCard.chooseExisting}
                </h4>

                <ul className="credit-cards-list" id="credit-cards-list">
                    {cards.map(card => (
                        <ZepzCreditCard
                            key={card.id}
                            card={card}
                            genericError={genericError}
                            isSubmitting={isSubmitting}
                            translations={translations}
                            onSubmit={onSubmit}
                            onRemove={removeCard}
                        />
                    ))}
                </ul>
                <div id="three-ds-container" ref={threeDSContainer} />
            </div>
        </section>
    );
};

ZepzCardSelection.propTypes = {
    cards: PropTypes.arrayOf(ZepzPayinPropTypes.Card).isRequired,
    csrfToken: PropTypes.string.isRequired,
    translations: ZepzPayinPropTypes.Translations.isRequired,
    genericError: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    toggleFormVisibility: PropTypes.func.isRequired
};

ZepzCardSelection.defaultProps = {
    genericError: false
};

export default ZepzCardSelection;
